// extracted by mini-css-extract-plugin
export var actionText = "_q1-4";
export var container = "_q1-0";
export var leftSection = "_q1-1";
export var rightSection = "_q1-2";
export var settingsButton = "_q1-6";
export var settingsIcon = "_q1-7";
export var shortcut = "_q1-5";
export var shortcutGroup = "_q1-3";